/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../../store/actions";
import { i18n } from '../../../../translate/i18n';
import {
	FormControl, Button, IconButton, FormControlLabel, Switch,
} from '@mui/material';
import { FilterList, ArrowUpward, ArrowDownward } from "@mui/icons-material";
import CloseIcon from '@mui/icons-material/Close';

import { DivFormTitle } from './styles';
import Autocomplete from '../../../../UI/Autocomplete/Autocomplete';

const EquipmentFilterModal = (props) => {
	const dispatch = useDispatch();

	const [page] = useState(1);
	const [limit] = useState(30);
	const [orderBy] = useState("name");
	const [order] = useState("asc");

	const [searchTextEquipment, setSearchTextEquipment] = useState('');
	const [equipmentsFormated, setEquipmentsFormated] = useState([]);
	const [selectedEquipments, setSelectedEquipments] = useState([]);

	const [searchTextPlace, setSearchTextPlace] = useState('');
	const [placesFormated, setPlacesFormated] = useState([]);
	const [selectedPlaces, setSelectedPlaces] = useState([]);

	const [searchTextSite, setSearchTextSite] = useState('');
	const [sitesFormated, setSitesFormated] = useState([]);
	const [selectedSites, setSelectedSites] = useState([]);

	const [searchTextGroup, setSearchTextGroup] = useState('');
	const [groupsFormated, setGroupsFormated] = useState([]);
	const [selectedGroups, setSelectedGroups] = useState([]);

  const [searchTextArea, setSearchTextArea] = useState('');
	const [areasFormated, setAreasFormated] = useState([]);
	const [selectedAreas, setSelectedAreas] = useState([]);

	const [searchTextCompanies, setSearchTextCompanies] = useState('');
	const [companiesFormated, setCompaniesFormated] = useState([]);
	const [selectedCompanies, setSelectedCompanies] = useState([]);

	const [deletedEquipments, setDeletedEquipments] = useState(false);

	const initialStatus = {
		valid: false,
		validWithOpenedActions: false,
		invalid: {
			inDelay: false,
			notDone: false,
			hasNoServices: false,
			hasActionsOpenedOrOverdue: false,
			mixed: false
		},
		maintenance: false,
		inactive: false
	};

	const [status, setStatus] = useState(initialStatus);
	const [statusInvalidDropdown, setStatusInvalidDropdown] = useState(false);


	const fetchPlaces = useCallback(
		() => dispatch(actions.equipmentsFetchPlacesLeafs(selectedSites)),
		[selectedSites]
	);

	const fetchSites = useCallback(
		() => dispatch(actions.fetchSites(page, limit, searchTextSite, order, orderBy)),
		[page, limit, searchTextSite, order, orderBy]
	);

	const fetchEquipments = useCallback(
		() => dispatch(actions.equipmentsFetchEquipmentModels(page, limit, searchTextEquipment, order, orderBy)),
		[page, limit, searchTextEquipment, order, orderBy]
	);

	const fetchGroups = useCallback(
		() => dispatch(actions.equipmentsFetchGroups(page, limit, searchTextGroup, order, orderBy)),
		[page, limit, searchTextGroup, order, orderBy]
	);

  const fetchAreas = useCallback(
		() => dispatch(actions.equipmentsFetchAreas(page, limit, searchTextArea, order, orderBy)),
		[page, limit, searchTextArea, order, orderBy]
	);

	const fetchCompanies = useCallback(
		() => dispatch(actions.equipmentsFetchCompanies(page, limit, searchTextCompanies, order, orderBy)),
		[page, limit, searchTextCompanies, order, orderBy]
	);

	const role = useSelector(state => state.auth.selectedAccess.role);
	const sites = useSelector(state => state.sites.sites);
	const places = useSelector(state => state.equipments.placesLeafs);
	const equipments = useSelector(state => state.equipments.equipmentModels);
	const groups = useSelector(state => state.equipments.groups);
	const areas = useSelector(state => state.equipments.areas);
	const companies = useSelector(state => state.equipments.companies);
	const filteredSites = useSelector(state => state.sites.selectedSitesPlaces);
	const filteredPlaces = useSelector(state => state.equipments.filters.filteredPlaces);
	const filteredEquipments = useSelector(state => state.equipments.filters.filteredModels);
	const filteredGroups = useSelector(state => state.equipments.filters.filteredGroups);
	const filteredAreas = useSelector(state => state.equipments.filters.filteredAreas);
	const filteredCompanies = useSelector(state => state.equipments.filters.filteredCompanies);
	const filteredStatus = useSelector(state => state.equipments.filters.filteredStatus);
	const filterDeletedEquipments = useSelector(state => state.equipments.filters.filterDeletedEquipments);

	const loadingSites = useSelector(state => state.sites.loading);
	const loadingEquipments = useSelector(state => state.equipments.equipmentModelsLoading);
	const loadingPlaces = useSelector(state => state.equipments.placesLoading);
	const loadingGroups = useSelector(state => state.equipments.groupsLoading);
	const loadingAreas = useSelector(state => state.equipments.areasLoading);
	const loadingCompanies = useSelector(state => state.equipments.companiesLoading);


	useEffect(() => {
		handleInputChangeSites(filteredSites);
		handleInputChangePlaces(filteredPlaces);
		handleInputChangeEquipments(filteredEquipments);
		handleInputChangeGroups(filteredGroups);
		handleInputChangeAreas(filteredAreas);
		handleInputChangeCompanies(filteredCompanies);
		setStatus(filteredStatus)
		setDeletedEquipments(filterDeletedEquipments)
	}, []);

	useEffect(() => {
		fetchPlaces(selectedSites);
	}, [selectedSites]);

	useEffect(() => {
		fetchSites(limit, searchTextSite, order, orderBy);
	}, [searchTextSite]);

	useEffect(() => {
		fetchEquipments(limit, searchTextEquipment, order, orderBy);
	}, [searchTextEquipment]);

	useEffect(() => {
		fetchGroups(limit, searchTextGroup, order, orderBy);
	}, [searchTextGroup]);

  useEffect(() => {
		fetchAreas(limit, searchTextArea, order, orderBy);
	}, [searchTextArea]);

	useEffect(() => {
		if (role !== 'contractor') {
      fetchCompanies(limit, searchTextCompanies, order, orderBy);
    }
	}, [searchTextCompanies]);

	useEffect(() => {
		const dataFromRedux = places
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.path }))
		setPlacesFormated(returnArray)
	}, [places])

	useEffect(() => {
		const dataFromRedux = sites
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
		setSitesFormated(returnArray)
	}, [sites])

	useEffect(() => {
		const dataFromRedux = equipments
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setEquipmentsFormated(returnArray)
	}, [equipments])

	useEffect(() => {
		const dataFromRedux = groups
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setGroupsFormated(returnArray)
	}, [groups])

  useEffect(() => {
		const dataFromRedux = areas
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setAreasFormated(returnArray)
	}, [areas])

	useEffect(() => {
		const dataFromRedux = companies
		let returnArray = []
		dataFromRedux.rows.map(dt => returnArray.push({ value: dt._id, label: dt.name }))
		setCompaniesFormated(returnArray)
	}, [companies])

	useEffect(() => {
		setDeletedEquipments(filterDeletedEquipments);
	}, [filterDeletedEquipments])

	const handleInputChangeSelectorPlaces = (text) => {
		setSearchTextPlace(text);
	}

	const handleInputChangeSelectorSites = (text) => {
		setSearchTextSite(text);
	}

	const handleInputChangeSelectorEquipments = (text) => {
		setSearchTextEquipment(text);
	}

	const handleInputChangeSelectorGroups = (text) => {
		setSearchTextGroup(text);
	}

	const handleInputChangeGroups = (selected) => {
		setSelectedGroups(selected);
	}

  const handleInputChangeSelectorAreas = (text) => {
		setSearchTextArea(text);
	}

	const handleInputChangeSelectorCompanies = (text) => {
		setSearchTextCompanies(text);
	}

  const handleInputChangeAreas = (selected) => {
		setSelectedAreas(selected);
	}

	const handleInputChangePlaces = selected => {
		setSelectedPlaces(selected);
	}

	const handleInputChangeEquipments = selected => {
		setSelectedEquipments(selected);
	}

	const handleInputChangeCompanies = selected => {
		setSelectedCompanies(selected);
	}

	const handleInputChangeSites = selected => {
		if(selected) {
			const dataFromRedux = selected
			let returnArray = []
			dataFromRedux.map(dt => returnArray.push({ value: dt._id, label: dt.name, ...dt }))
			setSelectedSites(returnArray);
		} else {
			setSelectedSites([]);
		}
	}

	const handleClickFilter = () => {
		dispatch(actions.setSitePlaces(selectedSites));
		dispatch(actions.filterEquipmentPlaces(selectedPlaces));
		dispatch(actions.filterEquipmentModels(selectedEquipments));
		dispatch(actions.filterEquipmentGroups(selectedGroups));
		dispatch(actions.filterEquipmentAreas(selectedAreas));
		dispatch(actions.filterEquipmentCompanies(selectedCompanies));
		dispatch(actions.filterEquipmentStatus({
			...status,
			invalid: {
				...status.invalid,
				mixed: false
			}
		}));
		dispatch(actions.filterDeletedEquipments(deletedEquipments))
		props.closeModal();
	}

	const handleClickClearFilters = () => {
		setSelectedPlaces([])
		setSelectedEquipments([])
		setSelectedGroups([])
		setSelectedAreas([])
		setSelectedCompanies([])
		setStatus(initialStatus)
		setDeletedEquipments(false)
	}

	const handleChangeStatus = (key, value) => {
		if (key === 'invalid') {
			setStatus({
				...status,
				invalid: {
					inDelay: value,
					notDone: value,
					hasNoServices: value,
					hasActionsOpenedOrOverdue: value,
				}
			});
		} else if (key.includes('invalid.')) {
			const invalidKey = key.split('.')[1];
			setStatus({ ...status, invalid: { ...status.invalid, [invalidKey]: value } });
		} else {
			setStatus({ ...status, [key]: value });
		}
	};

	return (
        <div style={styles.container}>
			<DivFormTitle style={styles.headerContainer}>
				<div style={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}>
					<FilterList style={{ marginRight: '1rem' }} />
					{i18n.t('filterListModalFilterEquip.text')}
					{((selectedPlaces && selectedPlaces.length > 0) ||
					(selectedSites && selectedSites.length > 0))
					&& <div style={styles.clearFilter} onClick={handleClickClearFilters}>{i18n.t('filterListModalFilterEquip.clear')}</div>}
				</div>
				<IconButton onClick={props.closeModal} color='inherit' size="large">
					<CloseIcon />
				</IconButton>
			</DivFormTitle>
			<div style={styles.bodyContainer}>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingSites}
						label={i18n.t('autocompleteModalFilterEquip.site')}
						data={sitesFormated}
						onSelectValue={handleInputChangeSites}
						valueSelected={selectedSites}
						newSearchText={handleInputChangeSelectorSites}
						id="site"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingEquipments}
						label={i18n.t('autocompleteModalFilterEquip.equipmentModel')}
						data={equipmentsFormated}
						onSelectValue={handleInputChangeEquipments}
						valueSelected={selectedEquipments}
						newSearchText={handleInputChangeSelectorEquipments}
						id="equipmentModel"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingGroups}
						label={i18n.t('autocompleteModalFilterEquip.groups')}
						data={groupsFormated}
						onSelectValue={handleInputChangeGroups}
						valueSelected={selectedGroups}
						newSearchText={handleInputChangeSelectorGroups}
						id="equipmentGroup"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingPlaces}
						label={i18n.t('autocompleteModalFilterEquip.place')}
						data={placesFormated}
						onSelectValue={handleInputChangePlaces}
						valueSelected={selectedPlaces}
						newSearchText={handleInputChangeSelectorPlaces}
						id="place"
						isMulti
					/>
				</FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					<Autocomplete
						loading={loadingAreas}
						label={i18n.t('autocompleteModalFilterEquip.area')}
						data={areasFormated}
						onSelectValue={handleInputChangeAreas}
						valueSelected={selectedAreas}
						newSearchText={handleInputChangeSelectorAreas}
						id="area"
						isMulti
					/>
				</FormControl>
        <FormControl variant="standard" fullWidth margin='normal'>
          <Autocomplete
            loading={loadingCompanies}
            label={i18n.t('autocompleteModalFilterEquip.company')}
            data={companiesFormated}
            onSelectValue={handleInputChangeCompanies}
            valueSelected={selectedCompanies}
            newSearchText={handleInputChangeSelectorCompanies}
            id="company"
            isMulti
          />
        </FormControl>
				<FormControl variant="standard" fullWidth margin='normal'>
					{i18n.t('autocompleteModalFilterEquip.status')}
					<FormControlLabel
						control={<Switch checked={status.valid} onChange={e => handleChangeStatus('valid', e.target.checked)} />}
						label={i18n.t('statusOptions.valid')}
					/>
					<FormControlLabel
						control={<Switch checked={status.validWithOpenedActions} onChange={e => handleChangeStatus('validWithOpenedActions', e.target.checked)} />}
						label={i18n.t('statusOptions.validWithOpenedActions')}
					/>
					<div style={{display: 'flex', alignItems: 'center'}}>
						<FormControlLabel
							control={
								<Switch
									checked={
										status.invalid.inDelay ||
										status.invalid.notDone ||
										status.invalid.hasNoServices ||
										status.invalid.hasActionsOpenedOrOverdue
									}
									onChange={e => handleChangeStatus('invalid', e.target.checked)}
								/>}
							label={i18n.t('statusOptions.invalid')}
						/>
						{statusInvalidDropdown
							? <IconButton onClick={() => setStatusInvalidDropdown(false)} size="large"><ArrowUpward/></IconButton>
							: <IconButton onClick={() => setStatusInvalidDropdown(true)} size="large"><ArrowDownward/></IconButton>}
					</div>
					{statusInvalidDropdown &&
						<div style={{marginLeft: 20, display: 'flex', flexDirection: 'column'}}>
							<FormControlLabel
								control={<Switch checked={status.invalid.inDelay} onChange={e => handleChangeStatus('invalid.inDelay', e.target.checked)} />}
								label={i18n.t('statusOptions.inDelay')}
							/>
							<FormControlLabel
								control={<Switch checked={status.invalid.notDone} onChange={e => handleChangeStatus('invalid.notDone', e.target.checked)} />}
								label={i18n.t('statusOptions.notDone')}
							/>
							<FormControlLabel
								control={<Switch checked={status.invalid.hasActionsOpenedOrOverdue} onChange={e => handleChangeStatus('invalid.hasActionsOpenedOrOverdue', e.target.checked)} />}
								label={i18n.t('statusOptions.hasActionsOpenedOrOverdue')}
							/>
							<FormControlLabel
								control={<Switch checked={status.invalid.hasNoServices} onChange={e => handleChangeStatus('invalid.hasNoServices', e.target.checked)} />}
								label={i18n.t('statusOptions.hasNoServices')}
							/>
						</div>
					}
					<FormControlLabel
						control={<Switch checked={status.maintenance} onChange={e => handleChangeStatus('maintenance', e.target.checked)} />}
						label={i18n.t('statusOptions.maintenance')}
					/>
					<FormControlLabel
						control={<Switch checked={status.inactive} onChange={e => handleChangeStatus('inactive', e.target.checked)} />}
						label={i18n.t('statusOptions.inactive')}
					/>
				</FormControl>

				{role === 'admin' &&
					<FormControl variant="standard" fullWidth margin='normal'>
					{i18n.t('adminOptions.showDeletedTitle')}
					<FormControlLabel
						label={i18n.t('adminOptions.showDeleted')}
						control={<Switch checked={deletedEquipments} onChange={e => setDeletedEquipments(e.target.checked)} />}
					/>
				</FormControl>}

			</div>
			<div style={styles.footerContainer}>
				<div
					onClick={props.closeModal}
					style={styles.buttonCancel}
				>
					{i18n.t('divModalFilterEquip.cancel')}
				</div>
				<Button
					variant='contained'
					color='primary'
					onClick={handleClickFilter}
					style={styles.button}
				>
					{i18n.t('divModalFilterEquip.ok')}
				</Button>
			</div>
		</div>
    );
}

const styles = {
	container: {
		width: '40rem',
		height: '100%'
	},
	headerContainer: {
		height: '5rem',
		padding: '0 1rem 0 2rem',
		backgroundColor: 'green',
		color: '#fff',
	},
	bodyContainer: {
		height: 'calc(100% - 10rem)',
		padding: '1rem 2rem',
		overflowY: 'auto',
		borderTop: '1px solid #ccc',
		borderBottom: '1px solid #ccc',
	},
	chip: {
		display: 'flex',
		alignItems: 'center',
		backgroundColor: '#C5D1E3',
		margin: '0.5rem 0',
		borderRadius: 10,
		padding: '0.3rem 1rem',
		justifyContent: 'space-between'
	},
	footerContainer: {
		height: '5rem',
		padding: '0 2rem',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	button: {
		flex: 1,
		backgroundColor: 'green',
		borderRadius: '2rem',
		padding: '0.5rem 1.5rem',
		// width: '100%',
	},
	buttonCancel: {
		flex: 1,
		cursor: 'pointer',
		color: 'grey',
		alignItems: 'center',
		textAlign: 'center',
	},
	clearFilter: {
		fontSize: '1rem',
		marginLeft: '2rem',
		color: '#fff',
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}

export default EquipmentFilterModal;
